import styled from 'styled-components';
import { Layout } from 'antd';
import { media, BREAKPOINTS } from '../../../../styles/themes/constants';

export const Sider = styled.menu`
  width: 100%;
  padding: 0 16px;
  margin: 0;
  
  .ant-tree {
    background: transparent;
    font-size: 14px;
    
    .ant-tree-switcher {
      width: 20px;
    }
    
    .ant-tree-node-content-wrapper {
      padding: 6px 8px;
      border-radius: 8px;
      transition: all 0.2s ease;
      
      &:hover {
        background: rgba(22, 119, 255, 0.08);
      }
    }
    
    .ant-tree-title {
      a.container {
        color: #434343;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
        display: block;
        transition: color 0.2s;
        
        &:hover {
          color: #1677ff;
        }
      }
    }
    
    .ant-tree-treenode-selected {
      .ant-tree-node-content-wrapper {
        background: rgba(22, 119, 255, 0.1) !important;
      }
      
      a.container {
        color: #1677ff;
      }
    }
  }
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 0 8px;
    
    .ant-tree {
      font-size: 15px;
      
      .ant-tree-node-content-wrapper {
        padding: 10px 12px;
      }
      
      .ant-tree-title {
        a.container {
          font-size: 15px;
        }
      }
    }
  }
`;

export const LayoutMain = styled(Layout)`
  @media only screen and ${media.md} {
    margin-left: 80px;
  }

  @media only screen and ${media.xl} {
    margin-left: unset;
  }
`;
